<template>
    <v-card>
        <v-card-title>
        <span class="headline">Claim Type Attachment</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm6 v-if="mode === 'new'">
                <v-autocomplete :items="appIdList" v-model="selectedClmTypeAttach.appId" :label="labels.appId" item-text="label" item-value="value"
                  data-vv-name="appId" :data-vv-as="labels.appId" :error-messages="errors.collect('appId')" v-validate="'required'"
                  @change="selectedClmTypeAttach.clmType=undefined;selectedClmTypeAttach.clmSubType=undefined"/>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.appId}}</v-subheader>
                <div class="title">{{appId[selectedClmTypeAttach.appId]}}</div>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeAttach.clmType" :label="labels.clmType" :error-messages="errors.collect('clmType')" v-validate="'required'"
                  data-vv-name="clmType" :data-vv-as="labels.clmType" :items="filteredClmTypeList" item-text="label" item-value="clmType" :loading="loading"
                  @change="generateSubTypeList();selectedClmTypeAttach.clmSubType=undefined"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.clmType}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{clmTypeMap[selectedClmTypeAttach.clmType]}}</div>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeAttach.clmSubType" :label="labels.clmSubType" :error-messages="errors.collect('clmSubType')" v-validate="'required'"
                  data-vv-name="clmSubType" :data-vv-as="labels.clmSubType" :items="filteredClmSubTypeList" item-text="label" item-value="clmSubType" :loading="loadingSub"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.clmSubType}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{clmSubTypeMap[selectedClmTypeAttach.clmSubType]}}</div>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-if="mode === 'new'" v-model="selectedClmTypeAttach.attachRef" :label="labels.attachRef" :error-messages="errors.collect('attachRef')" v-validate="'required|max:4'"
                  data-vv-name="attachRef" :data-vv-as="labels.attachRef"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.attachRef}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{selectedClmTypeAttach.attachRef}}</div>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete v-if="mode === 'review' || mode === 'new'" v-model="selectedClmTypeAttach.seqNo" :label="labels.seqNo" :error-messages="errors.collect('seqNo')" data-vv-name="seqNo"
                  v-validate="'required'" :data-vv-as="labels.seqNo" :items="seqNoList" item-text="label" item-value="value" />
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.seqNo}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmTypeAttach.seqNo}}</div>
              </v-flex>
              <v-flex xs12 md6/>
              <v-flex xs12 md12>
                <v-text-field v-if="mode === 'review' || mode === 'new'" v-model="selectedClmTypeAttach.attachRefDesc" :label="labels.attachRefDesc" :error-messages="errors.collect('attachRefDesc')"
                  v-validate="'required|max:200'" data-vv-name="attachRefDesc" :data-vv-as="labels.attachRefDesc"/>
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.attachRefDesc}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmTypeAttach.attachRefDesc}}</div>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete v-if="mode === 'review' || mode === 'new'" v-model="selectedClmTypeAttach.noCopies" :label="labels.noCopies" :error-messages="errors.collect('noCopies')" v-validate="'required'"
                  data-vv-name="noCopies" :data-vv-as="labels.noCopies" :items="noCopiesList" item-text="label" item-value="value"/>
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.noCopies}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{noCopiesMap[selectedClmTypeAttach.noCopies]}}</div>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox :readonly="mode === 'query'" v-model="selectedClmTypeAttach.isMand" :label="labels.isMand" data-vv-name="isMand" :data-vv-as="labels.isMand"
                  :error-messages="errors.collect('isMand')"/>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel" :disabled="submitting">Cancel</v-btn>
        <v-btn color="primary" v-if="mode === 'review' || mode === 'new'" flat @click.native="doSave" :loading="submitting">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'selectedClmTypeAttach': Object,
    'mode': String
  },
  data() {
    return {
      labels: {
        appId: 'Module',
        clmType: 'Claim Type*',
        clmSubType: 'Claim Sub Type*',
        attachRef: 'Attachment Ref*',
        attachRefDesc: 'Description*',
        seqNo: 'Sequence No.*',
        isMand: 'Mandatory',
        noCopies: 'No. of Copies'
      },
      clmTypeList: [],
      clmTypeMap: {},
      clmSubTypeList: [],
      clmSubTypeMap: {},
      filteredClmSubTypeList: [],
      appId: {
        'TR': 'Travel',
        'MD': 'Maid',
        'FI': 'Fire'
      },
      seqNoList: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 }
      ],
      noCopiesList: [
        { label: 'Single', value: 'S' },
        { label: 'Multiple', value: 'M' }
      ],
      noCopiesMap: {
        S: 'Single',
        M: 'Multiple'
      },
      loading: false,
      loadingSub: false,
      submitting: undefined
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    appIdList() {
      let result = []
      let appID = this.appId
      Object.keys(appID).forEach(function (key) {
        const status = appID[key]
        result.push({
          label: key + ' - ' + status,
          value: key
        })
      })
      return result
    },
    filteredClmTypeList() {
      return this.clmTypeList.filter(x => {
        return x.appId === this.selectedClmTypeAttach.appId
      })
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.loadClaimTypes()
      this.loadClaimSubTypes()
    },
    async loadClaimTypes() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.clmTypeList = []
            data.map((clmType) => {
              clmType.label = clmType.clmType + ' - ' + clmType.clmTypeDesc
              this.clmTypeList.push(clmType)
              this.clmTypeMap[clmType.clmType] = clmType.label
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim types (Missing API URL)')
      }
      this.loading = false
    },
    async loadClaimSubTypes() {
      this.loadingSub = true
      const apiUrl = this.$store.state.claimParam.menu.getClmSubTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.clmSubTypeList = []
            data.map((clmSubType) => {
              clmSubType.label = clmSubType.clmSubType + ' - ' + clmSubType.clmSubTypeDesc
              this.clmSubTypeMap[clmSubType.clmSubType] = clmSubType.label
              this.clmSubTypeList.push(clmSubType)
            })
            this.loadingSub = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loadingSub = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim sub types (Missing API URL)')
      }
      this.generateSubTypeList()
      this.loadingSub = false
    },
    generateSubTypeList() {
      const filteredClmSubTypeList = []
      this.filteredClmSubTypeList = filteredClmSubTypeList
      const clmType = this.selectedClmTypeAttach.clmType
      if (clmType && this.clmSubTypeList) {
        this.clmSubTypeList.forEach(function(clmSubType) {
          if (clmSubType.clmType === clmType) {
            filteredClmSubTypeList.push(clmSubType)
          }
        })
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.mode === 'new') this.doCreate()
          if (this.mode === 'review') this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.claimParam.menu.createClmTypeAttach
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.selectedClmTypeAttach)
          const { data } = result
          if (data.attachRef) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.claimParam.menu.updateClmTypeAttach
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.selectedClmTypeAttach)
          const { data } = result
          if (data.attachRef) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.resetMessages()
      this.$emit('close')
    },
    filterByClmType(item, queryText, itemText) {

    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
